module.exports = __webpack_public_path__ + "static/media/C7.94265810.jpg";